import { useMemo } from 'react';
import { BendBigCircle } from '@bendhealth/common';
import { Patient } from 'api/account/patients.type';
import { Slot } from 'components/_temp_ui_common/api/getAvailability';
import { AppointmentDetailBubbles } from 'components/_temp_ui_common/Appointments/AppointmentDetailBubbles';
import { Appointment } from 'components/_temp_ui_common/Appointments/types';
import { Calendar } from 'components/_temp_ui_common/Calendar/Calendar';
import { coerceToDate } from 'components/_temp_ui_common/dates/coerceToDate';
import { toMMDD } from 'components/_temp_ui_common/dates/formats';
import { preferredName } from 'components/_temp_ui_common/utilities/preferredName';
import { Text } from 'components/core/text/Text';
import { addDays, format } from 'date-fns';

export interface SchedulingCalendarProps {
  appointment: Appointment;
  member: Patient;
  onSelectSlot: (slot: Slot) => void;
}

export const SchedulingCalendar = ({
  appointment,
  member,
  onSelectSlot,
}: SchedulingCalendarProps) => {
  const beforeDate = useMemo(
    () =>
      appointment && appointment.scheduleBeforeDate
        ? toMMDD(appointment?.scheduleBeforeDate)
        : '',
    [appointment],
  );

  const afterDate = useMemo(() => {
    if (!appointment || !appointment.scheduleAfterDate) {
      return '';
    }

    let earliestDate = new Date();
    earliestDate.setHours(0);
    earliestDate.setMinutes(0);
    earliestDate = addDays(earliestDate, 3);

    let soonest = earliestDate;

    const scheduleAfterDate = coerceToDate(appointment.scheduleAfterDate);

    if (soonest < scheduleAfterDate) soonest = scheduleAfterDate;

    return format(soonest, 'MM/dd');
  }, [appointment]);
  return (
    <>
      <BendBigCircle />
      <Text block variant="subheadline2" className="pt-4">
        {preferredName(member)}&apos;s
      </Text>
      <Text block variant="text2" bold>
        {appointment.name}
      </Text>
      <AppointmentDetailBubbles appointment={appointment} />
      <Text variant="text5" className="pb-4">
        Choose a time between: {afterDate} and {beforeDate}
      </Text>
      <Calendar
        onSelectSlot={onSelectSlot}
        showSkipButton={appointment.skippable}
      />
    </>
  );
};
